import React from "react";
import { personalInfo } from "../../data/portfolio";
import { useScrollReveal } from "../../hooks/useScrollReveal";
import { FiGithub, FiLinkedin, FiInstagram, FiGlobe } from "react-icons/fi";
import "./Footer.css";

function Footer() {
  const { name, social } = personalInfo;
  const [ref, visible] = useScrollReveal(0.2);

  return (
    <footer className="footer" ref={ref}>
      <div className={`container reveal reveal--up ${visible ? "reveal--visible" : ""}`}>
        <div className="footer__top">
          <div className="footer__brand">
            <span className="footer__logo">&lt;{name.split(" ")[0]} /&gt;</span>
            <p className="footer__tagline">Building digital experiences.</p>
          </div>

          <div className="footer__domain">
            <a
              href="https://virly.in"
              target="_blank"
              rel="noopener noreferrer"
              className="footer__domain-link"
            >
              <FiGlobe />
              <span className="footer__domain-name">virly.in</span>
            </a>
            <p className="footer__domain-meaning">
              <span className="footer__domain-part"><strong>vir</strong>aj</span>
              <span className="footer__domain-dot">&middot;</span>
              <span className="footer__domain-part"><strong>l</strong>alasaheb</span>
              <span className="footer__domain-dot">&middot;</span>
              <span className="footer__domain-part"><strong>y</strong>adav</span>
            </p>
          </div>

          <div className="footer__social">
            <a href={social.github} target="_blank" rel="noopener noreferrer" aria-label="GitHub">
              <FiGithub />
            </a>
            <a href={social.linkedin} target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
              <FiLinkedin />
            </a>
            <a href={social.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram">
              <FiInstagram />
            </a>
          </div>
        </div>

        <div className="footer__bottom">
          <p className="footer__copyright">
            &copy; {new Date().getFullYear()} All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
